<template>
    <ModalBase :show-modal="true" :esc-to-close="false" @close-modal="close" :auto-h="true" :narrow="true" :overlay-scrollb="false" >
        <template v-slot:maincontent>
            <div>
                <div>
                    <AnimationItem :animation="{ animationData: premiumCongrats.default, loop: false }" />
                </div>
                <h1>Congratulations!</h1>
                <h3>Your account is now Premium and you have access to all the features Gekko offers.</h3>
            </div>
        </template>
    </ModalBase>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import ModalBase from "@/components/base_components/ModalBase";
import * as premiumCongrats from '@/css/animations/premium-congrats.json'
import AnimationItem from '@/components/dashboard/ui/AnimationItem.vue';

export default {
    name: 'PremiumCongratsModal',
    components: { ModalBase, AnimationItem },
    data() {
        return {
            premiumCongrats: premiumCongrats
        }
    },
    methods: {
        close() {
            this.$emit('close');

            document.body.classList.remove('modal-on')
            this.closePremiumCongrats()
        },
        ...mapMutations({ 
            closePremiumCongrats: 'onboarding/CLOSE_PREMIUM_CONGRATS',
        }),
    }
}
</script>